export default {
  List: {
    // tilte đơn vị đã được phê duyệt
    Approved: "Đơn vị đã phê duyệt",
    AcceptPayment: "Danh sách ĐVCNTT",
    IdentificationRequest: "Yêu cầu định danh",
    MerchantsUsageStatus: "Tình hình sử dụng học phí không tiền mặt",
    //tilte đơn vị chua được phê duyệt
    UnApproved: "Đơn vị chưa phê duyệt",
    // filter
    ServiceType: "Loại hình",

    // Tiêu đề cho cột grid
    CreateDate: "Ngày đăng ký",
    UpdateDate: "Ngày cập nhật",
    ApprovalDate: "Ngày duyệt",
    MerchantCode: "Mã đơn vị",
    MerchantName: "Tên đơn vị",
    TaxNo: "Mã số thuế",
    PhoneNumber: "Số điện thoại",
    Email: "Email",
    Status: "Trạng thái",
    StatusProfile: "Trạng thái hồ sơ",
    ProfileContractUpdatedDate: "Ngày cập nhật hợp đồng",
    ProfileContractStatus: "Trạng thái hợp đồng",
    VAPartner: "Đối tác VA",
    VAPartnerStatus: "Trạng thái duyệt đối tác VA",
    BenefitBank: "Ngân hàng nhận thanh toán",
    StatusContract: "Trạng thái hợp đồng",
    MerchantType: "Loại hình",
    Province: "Tỉnh/Thành phố",
    District: "Quận/Huyện",
    CustomerType: "Loại khách hàng",
    StaffName: "Nhân viên kinh doanh",
    Budget: "ngân sách",
    TypeOfRisk: "Loại rủi ro",
    ActiveDate: "Ngày hoạt động",
    FilterMerchantCode: "Tìm theo tên, mã ĐVCNTT hoặc MST/MNS",
    SearchTextMerchant: "Nhập nội dung tìm kiếm",
    NameSale: "Nhân viên kinh doanh JETPAY",
    SaleMISA: "Kinh doanh MISA",
    GoverningUnitName: "Đơn vị chủ quản",
  },
  Button: {
    Agree: "Duyệt",
    Decline: "Từ chối",
    Update: "Yêu cầu cập nhật",
    Edit: "Sửa",
    CreateNewContract: "Tạo hợp đồng mới",
    Save: "Lưu",
    Close: "Đóng",
    Add: "Thêm",
    Send: "Gửi",
    Cancel: "Hủy",
    Function: "Chức năng",
    Ok: "OK",
    Receive: "Tiếp nhận",
    HistoryUpdate: "Lịch sử cập nhật",
    UpdateProfileActive: "Cập nhật",
    UpdateSaleProfile: "Gắn kinh doanh JETPAY",
    ChangeSale: "Gắn kinh doanh",
  },
  CheckBox: {
    Invalid: "Hồ sơ chưa hợp lệ",
    MerchantIsRisk: "Khách hàng rủi ro cao",
    HighRisk: "Rủi ro rất cao",
    Virtual: "Hồ sơ ảo",
    NoNeed: "Khách hàng không còn nhu cầu",
    More: "Khác",
  },
  TransactionStatus: {
    PaymentRequired: "Yêu cầu thanh toán",
    HandlingTransaction: "Đang xử lý giao dịch",
    PaymentFail: "Thanh toán thất bại",
    PaymentSuccess: "Thanh toán thành công",
    PaymentExpired: "Hết hạn thanh toán",
    TransactionCancle: "Hủy giao dịch",
  },
  Title: {
    Title: "Chi tiết đơn vị chấp nhận thanh toán",
    Decline: "Từ chối phê duyệt hồ sơ",
    Update: "Yêu cầu cập nhật hồ sơ",
    Message: "Thông báo",
    Merchant: "Thông tin đơn vị",
    Business: "Đăng ký kinh doanh",
    SchoolSetup: "Quyết định thành lập trường",
    PrincipalRepresent: "Hiệu trưởng",
    Represent: "Người đại diện pháp luật",
    Service: "Đăng ký dịch vụ",
    Contract: "Người ký hợp đồng",
    Control: "Thanh toán, đối soát",
    More: "Thông tin khác",
    Report: "Báo cáo tài chính",
    Companies: "Thông tin công ty mẹ/công ty con, các chi nhánh, văn phòng đại diện",
    AddMerchant: "Thêm đơn vị mới",
  },
  PlaceHolder: {
    SearchName: "Tên | MST | Mã ngân sách",
  },
  Label: {
    Status: "Trạng thái",
    TaxNo: "Mã số thuế",
    Address: "Địa chỉ",
    CreateDate: "Ngày gửi hồ sơ",
    ApprovalDate: "Ngày duyệt hồ sơ",
    MerchantType: "Loại hình",
    Business: "Ngành nghề",
    ServiceType: "Loại dịch vụ",
    Revenue: "Doanh thu trung bình 2 năm gần đây",
    AverageProduct: "Giá trị sản phẩm trung bình",
    AverageOrder: "Giá trị đơn hàng trung bình",
    BusinessImage: "Giấy đăng ký kinh doanh",
    License: "Giấy phép ngành nghề kinh doanh có điều kiện",
    Country: "Quốc tịch",
    Font: "Ảnh chụp CCCD/CC/HC (mặt trước)",
    Back: "Ảnh chụp CCCD/CC/HC (mặt sau)",
    BusinessArea: "Ảnh chụp địa điểm kinh doanh",
    Cashier: "Ảnh quầy thanh toán",
    CashierForPrivateSchool: "Ảnh chụp khu vực thu tiền",
    ExhibitionArea:
      "Ảnh khu vực trưng bày hàng hóa hoặc/và khu vực cung cấp công cụ thực hiện dịch vụ",
    ExhibitionAreaForPrivateSchool: "Ảnh chụp khu vực dạy học",
    Warehouse: "Ảnh kho hàng hóa hoặc/và khu vực cung cấp công cụ dịch vụ",
    ProductItem: "Danh sách hàng hóa dịch vụ kinh doanh",
    Name: "Họ và tên",
    IdentityNumber: "Số CCCD/CC/HC",
    IssuedPlace: "Nơi cấp",
    Position: "Chức vụ",
    EffectiveDate: "Ngày cấp",
    ExpirationDate: "Ngày hết hạn",
    IsContact: "Là người ký hợp đồng",
    IsHeadAccounting: "Là Kế toán trưởng",
    DocsAuthor: "Giấy ủy quyền",
    Reason: "Lí do",
    Visa: "Thị thực hoặc giấy tờ chứng minh được miễn thị thực nhập cảnh",
    PapersNumber: "Số giấy tờ",
    Domain: "Tên miền",
    DomainTitle: "Đăng ký dịch vụ kết nối Cổng thanh toán với website",
    DomainOwnershipCertificate: "Chứng nhận sở hữu hoá đơn/mua tên miền website",
    ControlPerson: "Người thực hiện đối soát",
    FullName: "Họ và tên",
    PaymentReceivingAccount: "Tài khoản nhận tiền thanh toán",
    BankName: "Ngân hàng",
    BranchName: "Chi nhánh",
    BranchOwner: "Chủ tài khoản",
    BankAccountNumber: "Số tài khoản",
    Year: "Năm",
    InActive: "Chưa hoạt động",
    Members: "Thành viên",
    OrdinalNumber: "STT",
    District: "Quận huyện",
    Provine: "Tỉnh/Thành Phố",
    Wards: "Phường/Xã",
    Type: "Loại",
    Representative: "Người đại diện",
    Billion: "tỷ",
    BillionMoney: "tỷ đồng",
    MoneyUnit: "VNĐ",
    MoneyUnit2: "đồng",
    ImgPassPort: " Ảnh chụp hộ chiếu",
    MerchantName: "Tên DVCNTT",
    MerchantNameCompany: "Tên Merchant",
    MerchantCode: "Mã merchant",
    TerminalName: "Tên Terminal",
    TerminalCode: "Mã Terminal",
    PartnerCode: "PartnerCode",
    AccessKey: "AccessKey",
    SecretKey: "SecretKey",
    PartnerName: "PartnerName",
    VTMerchantCode: "Mã đối tác",
    AccessCode: "AccessCode",
    HashKey: "HashKey",
  },
  Confirm: {
    MerchantApprove: "Thành công",
    MerchantDecline: "Hồ sơ đã bị từ chối",
    EmployeeApprove: "Bạn có muốn gửi hồ sơ sang bộ phận giám sát vận hành?",
    MonitorApprove: "Bạn có muốn gửi hồ sơ cho giám đốc phê duyệt?",
    LegislationApprove: "Bạn có muốn gửi hồ sơ cho pháp chế phê duyệt?",
    Approve: "Phê duyệt hồ sơ này?",
    Uppdate: "Bạn có chắc chắn muốn đơn vị này cập nhật thêm thông tin không?",
    Error: "Có lỗi xảy ra. Vui lòng thử lại",
    SaleConfirm: "Hồ sơ đã gửi lên giám sát vận hành phê duyệt",
    LegislationConfirm: "Hồ sơ đã gửi lên pháp chế phê duyệt",
    MonitorConfirm: "Hồ sơ đã gửi lên giám đốc phê duyệt",
    ManagerConfirm: "Phê duyệt thành công. Hồ sơ đã được chuyển sang danh sách phê duyệt",
    SaveMerchant: "Lưu thông tin hồ sơ thành công",
    MerchantUpdate: "Hồ sơ đã được gửi",
    ReceiveNewProfileConfirm: "Tiếp nhận hồ sơ này?",
    DeclineNewProfileConfirm: "Từ chối hồ sơ này?",
    ReceiveNewProfileSuccess: "Hồ sơ đã được tiếp nhận",
    DeclineNewProfileSuccess: "Hồ sơ đã bị từ chối",
  },
  Error: {
    OrganizationNotFound: "Thông tin đơn vị không được để trống",
    OrganizationCodeNotFound: "Mã số thuế hoặc mã ngân sách không được phép để trống",
    OrganizationCodeExist: "Mã số thuế hoặc mã ngân sách đã được sử dụng trên hệ thống",
    OrganizationCodeInvalid: "Mã số thuế không đúng định dạng",

    ProfileNotExist: "Thông tin hồ sơ không tồn tại",
    RegisterServiceNotExist: "Thông tin dịch vụ không tồn tại",
    MerchantAdminstratorNotExist: "Hồ sơ thiếu thông tin quản trị viên",
    MerchantCodeNotExist: "Mã merchant không tồn tại",
    CreateAccountNotSuccess: "Tạo tài khoản không thành công",
    ProfileInvalid: "Hồ sơ chưa hợp lệ. Vui lòng kiểm tra lại",
    ExistRequestUpdate: "Không được Duyệt hồ sơ đang tích chọn Yêu cầu cập nhật",
    InfoContractError: "Có lỗi phát sinh trong quá trình lưu thông tin hợp đồng",
  },
  Message: {
    NotEmpty: "Vui lòng nhập thời gian vào ô tìm kiếm.",
    FormatDateWrong: "Nhập sai định dạng thời gian. Vui lòng kiểm tra lại.",
    DisDateLong: "Khoảng cách Từ ngày - Đến ngày không quá 31 ngày.",
    FromDateLong: "Không thể tìm kiếm cách ngày hiện tại quá 180 ngày",
    DisDateFail: "Từ ngày không được vượt quá Đến ngày",
    ToDateFail: "Không được tìm kiếm vượt quá ngày hiện tại",
    UploadMaxFile: "Tối đa tải lên xxx file",
    InputUpdate: "Chưa nhập lí do yêu cầu cập nhật",
    InputDecline: "Chưa nhập lí do từ chối",
    Monitor: "Hồ sơ đã được gửi cho giám sát vận hành",
    Legislation: "Hồ sơ đã được gửi cho pháp chế",
    Manager: "Hồ sơ đã được gửi cho giám đốc",
    TypeProfile: "Bạn chưa chọn loại hồ sơ",
    Invalid: "Hồ sơ chưa hợp lệ",
    IsRisk: "Hồ sơ rủi ro cao",
    ChangeSaleSuccess: "Gắn kinh doanh JetPay thành công",
    ChangeSaleFailed: "Gắn kinh doanh JetPay thất bại",
    SaleInValid: "Thông tin kinh doanh không hợp lệ",
  },
  EditMerchant: {
    Warehouse: "Kho hàng hóa hoặc/và khu vực cung cấp công cụ thực hiện dịch vụ",
    WarehouseDescription:
      "Ảnh thấy được hình ảnh các hàng hóa, nguyên vật liệu để chế biến ra các hàng hóa hoặc hình ảnh khu vực phụ vụ khách hàng",
    CashierDescription:
      "Ảnh thấy được nơi thanh toán nhìn từ cửa vào hoặc máy tính tiền/ máy POS bán hàng/ két đựng tiền (nếu có)",
    ExhibitionareaDescription: "Ảnh thấy được nơi trưng bày hàng hóa hoặc cung cấp dịch vụ",
  },
  ConfigTransaction: "Cấu hình thanh toán",
  QrConfigTransaction: "Cấu hình thanh toán QR",
  MomoConfigTransaction: "Cấu hình thanh toán Momo",
  ViettelConfigTransaction: "Cấu hình thanh toán ViettelMoney",
  NoteQRProvider: {
    VCB: "QR VIETCOMBANK",
    VTB: "QR VIETINBANK",
  },
  EmployeeInCharge: {
    Title: "Nhân viên phụ trách",
    NameSaleJETPAY: "Nhân viên kinh doanh JETPAY",
    SaleMisa: "Kinh doanh MISA",
  },
  StopWorkingDetail: {
    Title: "Hồ sơ ngừng hoạt động",
    StopDate: "Ngày ngừng hoạt động",
    FileAttachment: "Hồ sơ đính kèm",
  },
};
